import { signInWithRedirect } from "aws-amplify/auth";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hub } from "aws-amplify/utils";
import { setupOAuthRedirect, ensureRedirectPath } from "../../util/redirectUtils";
import classes from "./SocialForm.module.css";
import appleLogo from "../../public/icons/socialIcons/apple logo.png";
import googleLogo from "../../public/icons/socialIcons/google image.png";
import facebookLogo from "../../public/icons/socialIcons/facebook logo.png";

const OAUTH_AUTH_INTENT_KEY = 'stu_oauth_auth_intent';

const SocialForm = ({ onTelephoneLogin, resetFirstBoxClicked, authIntent = 'login' }) => {
  const [firstBoxClicked, setFirstBoxClicked] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();

  useEffect(() => {
    const unsubscribe = Hub.listen("auth", ({ payload }) => {
      switch (payload?.event) {
        case "signInWithRedirect":
          break;
        case "signInWithRedirect_failure":
          setError("An error has occurred during the OAuth flow.");
          console.error("Sign-in error:", payload?.data);
          break;
        case "customOAuthState":
          break;
        default:
          break;
      }
    });

    return unsubscribe;
  }, []);

  useEffect(() => {
    if (resetFirstBoxClicked) {
      setFirstBoxClicked(true);
    }
  }, [resetFirstBoxClicked]);

  const handleSocialSignIn = async (provider) => {
    try {
      const normalizedAuthIntent = authIntent === 'signup' ? 'signup' : 'login';

      // Secondary safeguard: if intent marker is present, ensure redirect path
      const params = new URLSearchParams(location.search);
      const toParam = params.get('to');
      const toState = location.state?.to;
      if (toParam === 'studio-erstellen' || toState === 'studio-erstellen') {
        ensureRedirectPath('/studio-erstellen');
      }

      // Set up dynamic redirect URL to current page (won't overwrite explicit intent)
      setupOAuthRedirect();

      const providerMap = {
        'Google': 'Google',
        'Facebook': 'Facebook',
        'SignInWithApple': 'Apple'
      };
      
      // Include redirect target in customState to survive across full redirects
      let redirectTarget = sessionStorage.getItem('oauth_redirect_path');
      if (!redirectTarget && (toParam === 'studio-erstellen' || toState === 'studio-erstellen')) {
        redirectTarget = '/studio-erstellen';
      }

      try {
        sessionStorage.setItem(OAUTH_AUTH_INTENT_KEY, normalizedAuthIntent);
      } catch (e) {
        // OAuth still works without sessionStorage; redirect customState is the backup.
      }

      const customStatePayload = {
        source: normalizedAuthIntent === 'signup' ? 'social-signup' : 'social-login',
        authIntent: normalizedAuthIntent,
        redirect: redirectTarget || null,
      };

      await signInWithRedirect({
        provider: providerMap[provider],
        customState: encodeURIComponent(JSON.stringify(customStatePayload))
      });
    } catch (error) {
      console.error('Error with social sign in:', error);
      setError(error.message);
    }
  };

  const handleFirstBoxClick = () => {
    setFirstBoxClicked(prevState => !prevState);
    onTelephoneLogin();
  };

  useEffect(() => {
    if (resetFirstBoxClicked) {
      setFirstBoxClicked(true);
    }
  }, [resetFirstBoxClicked]);


  return (
    <div className={classes.socialForm}>
      {/* <div
        className={classes.socialBox}
        onClick={handleFirstBoxClick}
      >
        {firstBoxClicked ? (
          <>
            <div className={classes.logoContainer}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="17" viewBox="0 0 20 17" fill="none">
                <path d="M17.5875 16.3271H2.5875C1.2675 16.3271 0.1875 15.2471 0.1875 13.9271V2.9271C0.1875 1.6071 1.2675 0.5271 2.5875 0.5271H17.5875C18.9075 0.5271 19.9875 1.6071 19.9875 2.9271V13.9271C19.9875 15.2471 18.9075 16.3271 17.5875 16.3271ZM1.5175 1.7371C1.1975 2.0271 0.9875 2.4571 0.9875 2.9271V13.9271C0.9875 14.8071 1.7075 15.5271 2.5875 15.5271H17.5875C18.4675 15.5271 19.1875 14.8071 19.1875 13.9271V2.9271C19.1875 2.4571 18.9875 2.0371 18.6675 1.7471L9.9275 10.1471L9.3775 9.5671L1.5175 1.7371ZM2.2675 1.3571L9.9575 9.0171L17.9175 1.3571C17.8075 1.3371 17.6975 1.3271 17.5875 1.3271H2.5875C2.4775 1.3271 2.3675 1.3371 2.2675 1.3571Z" fill="#1F1F1F"/>
              </svg>
            </div>
            <span className="mediumLarge">Weiter mit E-Mail</span>
            <span></span>
          </>
        ) : (
          <>
            <div className={classes.logoContainer}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="24" viewBox="0 0 16 24" fill="none">
              <path fillRule="evenodd" clipRule="evenodd" d="M11.7589 0.831089H3.61607C3.00435 0.831089 2.58807 0.831637 2.2662 0.857855C1.95258 0.883402 1.79134 0.929763 1.67839 0.98714C1.40817 1.12441 1.18847 1.34343 1.05079 1.61283C0.993239 1.72544 0.946737 1.8862 0.921114 2.19887C0.894816 2.51976 0.894266 2.93478 0.894266 3.54465V20.2083C0.894266 20.8181 0.894816 21.2332 0.921114 21.5541C0.946737 21.8667 0.993239 22.0275 1.05079 22.1401C1.18847 22.4095 1.40817 22.6285 1.67839 22.7658C1.79134 22.8232 1.95258 22.8695 2.2662 22.8951C2.58807 22.9213 3.00436 22.9218 3.61607 22.9218H11.7589C12.3706 22.9218 12.7869 22.9213 13.1088 22.8951C13.4224 22.8695 13.5837 22.8232 13.6966 22.7658C13.9668 22.6285 14.1865 22.4095 14.3242 22.1401C14.3818 22.0275 14.4283 21.8667 14.4539 21.5541C14.4802 21.2332 14.4807 20.8181 14.4807 20.2083V3.54465C14.4807 2.93478 14.4802 2.51976 14.4539 2.19887C14.4283 1.8862 14.3818 1.72544 14.3242 1.61283C14.1865 1.34343 13.9668 1.12441 13.6966 0.98714C13.5837 0.929763 13.4224 0.883402 13.1088 0.857855C12.7869 0.831637 12.3706 0.831089 11.7589 0.831089ZM0.421057 1.29294C0.1875 1.74993 0.1875 2.34817 0.1875 3.54465V20.2083C0.1875 21.4048 0.1875 22.003 0.421057 22.46C0.6265 22.862 0.954316 23.1888 1.35752 23.3936C1.8159 23.6265 2.41596 23.6265 3.61607 23.6265H11.7589C12.959 23.6265 13.5591 23.6265 14.0175 23.3936C14.4207 23.1888 14.7485 22.862 14.9539 22.46C15.1875 22.003 15.1875 21.4048 15.1875 20.2083V3.54465C15.1875 2.34817 15.1875 1.74993 14.9539 1.29294C14.7485 0.890957 14.4207 0.564135 14.0175 0.359315C13.5591 0.126465 12.959 0.126465 11.7589 0.126465H3.61607C2.41596 0.126465 1.8159 0.126465 1.35752 0.359315C0.954316 0.564135 0.6265 0.890957 0.421057 1.29294Z" fill="black"/>
                <path d="M5.62661 8.62871C5.62661 9.19505 5.1661 9.65416 4.59805 9.65416C4.02999 9.65416 3.56949 9.19505 3.56949 8.62871C3.56949 8.06238 4.02999 7.60327 4.59805 7.60327C5.1661 7.60327 5.62661 8.06238 5.62661 8.62871Z" fill="#B1B6BB"/>
                <path d="M5.62661 11.7055C5.62661 12.2719 5.1661 12.731 4.59805 12.731C4.02999 12.731 3.56949 12.2719 3.56949 11.7055C3.56949 11.1392 4.02999 10.6801 4.59805 10.6801C5.1661 10.6801 5.62661 11.1392 5.62661 11.7055Z" fill="#B1B6BB"/>
                <path d="M5.62661 14.7824C5.62661 15.3487 5.1661 15.8078 4.59805 15.8078C4.02999 15.8078 3.56949 15.3487 3.56949 14.7824C3.56949 14.216 4.02999 13.7569 4.59805 13.7569C5.1661 13.7569 5.62661 14.216 5.62661 14.7824Z" fill="#B1B6BB"/>
                <path d="M5.62661 17.8592C5.62661 18.4256 5.1661 18.8847 4.59805 18.8847C4.02999 18.8847 3.56949 18.4256 3.56949 17.8592C3.56949 17.2929 4.02999 16.8338 4.59805 16.8338C5.1661 16.8338 5.62661 17.2929 5.62661 17.8592Z" fill="#B1B6BB"/>
                <path d="M8.71279 8.62871C8.71279 9.19505 8.25229 9.65416 7.68423 9.65416C7.11617 9.65416 6.65567 9.19505 6.65567 8.62871C6.65567 8.06238 7.11617 7.60327 7.68423 7.60327C8.25229 7.60327 8.71279 8.06238 8.71279 8.62871Z" fill="#B1B6BB"/>
                <path d="M8.71295 11.7054C8.71295 12.2718 8.25245 12.7309 7.68439 12.7309C7.11633 12.7309 6.65583 12.2718 6.65583 11.7054C6.65583 11.1391 7.11633 10.68 7.68439 10.68C8.25245 10.68 8.71295 11.1391 8.71295 11.7054Z" fill="#B1B6BB"/>
                <path d="M8.71279 14.7824C8.71279 15.3487 8.25229 15.8078 7.68423 15.8078C7.11617 15.8078 6.65567 15.3487 6.65567 14.7824C6.65567 14.216 7.11617 13.7569 7.68423 13.7569C8.25229 13.7569 8.71279 14.216 8.71279 14.7824Z" fill="#B1B6BB"/>
                <path d="M8.71279 17.8592C8.71279 18.4256 8.25229 18.8847 7.68423 18.8847C7.11617 18.8847 6.65567 18.4256 6.65567 17.8592C6.65567 17.2929 7.11617 16.8338 7.68423 16.8338C8.25229 16.8338 8.71279 17.2929 8.71279 17.8592Z" fill="#B1B6BB"/>
                <path d="M11.8009 8.62871C11.8009 9.19505 11.3404 9.65416 10.7724 9.65416C10.2043 9.65416 9.74383 9.19505 9.74383 8.62871C9.74383 8.06238 10.2043 7.60327 10.7724 7.60327C11.3404 7.60327 11.8009 8.06238 11.8009 8.62871Z" fill="#B1B6BB"/>
                <path d="M11.8019 11.7055C11.8019 12.2719 11.3414 12.731 10.7734 12.731C10.2053 12.731 9.74482 12.2719 9.74482 11.7055C9.74482 11.1392 10.2053 10.6801 10.7734 10.6801C11.3414 10.6801 11.8019 11.1392 11.8019 11.7055Z" fill="#B1B6BB"/>
                <path d="M11.8009 14.7824C11.8009 15.3487 11.3404 15.8078 10.7724 15.8078C10.2043 15.8078 9.74383 15.3487 9.74383 14.7824C9.74383 14.216 10.2043 13.7569 10.7724 13.7569C11.3404 13.7569 11.8009 14.216 11.8009 14.7824Z" fill="#B1B6BB"/>
                <path d="M11.8009 17.8592C11.8009 18.4256 11.3404 18.8847 10.7724 18.8847C10.2043 18.8847 9.74383 18.4256 9.74383 17.8592C9.74383 17.2929 10.2043 16.8338 10.7724 16.8338C11.3404 16.8338 11.8009 17.2929 11.8009 17.8592Z" fill="#B1B6BB"/>
              </svg>
            </div>
            <span className="mediumLarge">Weiter mit Telefonnummer</span>
          <span></span>
          </>
        )}
      </div> */}
      <div className={classes.socialBox} onClick={() => handleSocialSignIn('SignInWithApple')}>
        <div className={classes.appleLogo}>
          <img src={appleLogo} alt='login with apple account' />
        </div>
        <span className="mediumLarge">Weiter mit Apple</span>
        <span></span>
      </div>
      <div className={classes.socialBox} onClick={() => handleSocialSignIn('Google')}>
        <div className={classes.googleLogo}>
          <img src={googleLogo} alt='login with google account' />
        </div>
        <span className="mediumLarge">Weiter mit Google</span>
        <span></span>
      </div>
      {/* <div className={classes.socialBox} onClick={() => handleSocialSignIn('Facebook')}>
        <div className={classes.facebookLogo}>
          <img src={facebookLogo} alt='login with facebook account' />
        </div>
        <span className="mediumLarge">Weiter mit Facebook</span>
        <span></span>
      </div> */}
    </div>
  );
};

export default SocialForm;
